import React from "react";
import dayjs from "dayjs";
import { Clock } from "lucide-react";
import { PaymentMethodDetails } from "../../PaymentMethodDetails/PaymentMethodDetails";
import { TableV2 } from "../../../components";

export const OrderPaymentsTable = ({ order }: any) => {
  const column = [
    {
      title: "Date & Time",
      dataIndex: "payment_date",
      key: "payment_date",
      render: (v: string) => dayjs(v).format("YYYY-MM-DD HH:mm"),
    },
    {
      title: "Method",
      key: "payment_method_name",
      render: (_: any, rec: any) => {
        const code =
          rec.payment_method_code || rec.payment_method_name?.toLowerCase();
        return (
          <div className="flex flex-col gap-0.5">
            <span className="font-semibold capitalize text-gray-800">
              {rec.payment_method_name}
            </span>
            <PaymentMethodDetails type={code} data={rec} />
          </div>
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (v: number) =>
        `LKR ${v.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      render: (v: string) => v || "-",
    },
  ];

  return (
    <>
      <div>
        <h3 className="text-xs font-bold text-gray-800 mb-2 flex items-center gap-1.5">
          <Clock className="w-3.5 h-3.5 text-gray-400" />
          Payments Logged
        </h3>
        <TableV2
          dataSource={order.payments || []}
          columns={column}
          pagination={false}
          size="small"
          rowKey="id"
          bordered
          scroll={{ x: 700 }}
          mobileColumn={["payment_method_name", "amount"]}
        />
      </div>
    </>
  );
};
